(function(angular, schoolwork12) {
    'use strict';
    angular.module(schoolwork12.app.student.name)
        .factory(schoolwork12.app.student.services.personalGroupSvc, ['$http', '$q', function ($http, $q) {

        	var getAvailableGroups = function (keycode, identityId) {
                console.info('In getAvailableGroups service');
                console.info('Making a call to service...');
                var availableGroups = null;
                var deferred = $q.defer();
                var request = $http({  
                    method: 'POST',
                    url: schoolwork12.app.student.endpoints.personalGroupUrl + 'search',
                    data : {
                        "method": "searchGroups",
                        "parameters": [
                            {
                                "groupName": "",
                                "memberInformation": {
                                    "members": [identityId]
                                },
                                "clientContext": {
                                    "namespace": "IDENTITY_MANAGEMENT_SERVICE",
                                    "version": "1",
                                    "clientIPAddress": "1.1.1.1"
                                }
                            }
                        ]
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    availableGroups = response.data;
                    deferred.resolve(availableGroups);
                    console.info('Got available groups.');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
           

        	return {
                getAvailableGroups: getAvailableGroups,                
            };
       	} 

        ]);
}(angular, schoolwork12));